export default "__VITE_ASSET__a7f4ac92__"